import {
  IconBank,
  IconBuilding,
  IconFileText,
  IconHouseOutline,
} from '@iwoca/icons';
import clsx from 'clsx';
import { LayoutHeadings } from 'components/Layout/InnerLayout/LayoutHeadings/LayoutHeadings';
import { FeatureHighlight } from '../FeatureHighlight/FeatureHighlight';
import sharedStyles from '../Products.module.css';
import { UnlockFlexiLoanButton } from '../UnlockFlexiLoanButton/UnlockFlexiLoanButton';
import styles from './FlexiLoanProcess.module.css';

export const FlexiLoanProcess = () => {
  return (
    <div>
      <div className={sharedStyles.section}>
        <LayoutHeadings
          heading="Businesses eligible for a Flexi-Loan"
          headingVariant="long"
          headingAlignment="center"
        />
        <div className={sharedStyles.highlights}>
          <FeatureHighlight
            icon={IconBank}
            feature="UK Registered Companies"
            className={styles.largeHighlight}
          />
          <FeatureHighlight
            icon={IconBuilding}
            feature="Limited Companies and LLPs"
            description="no sole traders"
          />
          <FeatureHighlight
            icon={IconFileText}
            feature="12 months trading history"
            className={styles.largeHighlight}
          />
          <FeatureHighlight
            icon={IconHouseOutline}
            feature="Homeowners and non-homeowners"
          />
        </div>
      </div>
      <div className={clsx(sharedStyles.section, styles.howItWorksSection)}>
        <LayoutHeadings
          heading="How does it work?"
          headingVariant="long"
          headingAlignment="center"
        />

        <ul className={styles.steps}>
          <li className={styles.step}>
            <h3>1. Apply</h3>
            <p>
              Complete your client's application in just 5 minutes through our
              introducer portal and upload their documents where required.
            </p>
          </li>

          <li className={styles.step}>
            <h3>2. Feedback in 24 hours</h3>
            <p>
              You’ll get feedback on all your applications or receive an offer
              breakdown for approved customers.
            </p>
          </li>

          <li className={styles.step}>
            <h3>3. Drawdown</h3>
            <p>
              Confirm your client wants to take the offer and their dedicated
              account manager will help them through the drawdown process.
            </p>
          </li>

          <li className={styles.step}>
            <h3>4. Earn commission</h3>
            <p>
              Once we’ve funded your client, we’ll then pay you any commission
              due.
            </p>
          </li>
        </ul>
        <UnlockFlexiLoanButton />
      </div>
    </div>
  );
};
